import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';
import { BEACON_SUBTABS } from 'src/components/BeaconV2Components/GenericSidebarNav/useBeaconRoutes';
import ContentUtilizationV3Page from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/ContentUtilizationV3Page';
import ContentAccuracyV3Page from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/ContentAccuracyV3Page';
import ContentKeywordsV3Page from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/ContentKeywordsV3Page';
import ContentVariationsPage from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/ContentVariationsPage';

const getContentV3PageLayout = ({ metricType }) => {
  if (metricType === BEACON_SUBTABS.CONTENT_UTILIZATION) {
    return {
      CustomPageContainer: GenericPageContainer,
      enableComparison: false,
      widgets: [
        {
          name: BEACON_SUBTABS.CONTENT_UTILIZATION,
          CustomComponent: ContentUtilizationV3Page,
          view: {}
        }
      ],
      containerStyle: {},
      dataConfig: {}
    };
  }

  if (metricType === BEACON_SUBTABS.CONTENT_ACCURACY) {
    return {
      CustomPageContainer: GenericPageContainer,
      enableComparison: false,
      widgets: [
        {
          name: BEACON_SUBTABS.CONTENT_ACCURACY,
          CustomComponent: ContentAccuracyV3Page,
          view: {}
        }
      ],
      containerStyle: {},
      dataConfig: {}
    };
  }
  if (metricType === BEACON_SUBTABS.CONTENT_KEYWORDS) {
    return {
      CustomPageContainer: GenericPageContainer,
      enableComparison: false,
      widgets: [
        {
          name: BEACON_SUBTABS.CONTENT_KEYWORDS,
          CustomComponent: ContentKeywordsV3Page,
          view: {}
        }
      ],
      containerStyle: {},
      dataConfig: {}
    };
  }
  if (metricType === BEACON_SUBTABS.CONTENT_VARIATIONS) {
    return {
      CustomPageContainer: GenericPageContainer,
      enableComparison: false,
      widgets: [
        {
          name: BEACON_SUBTABS.CONTENT_VARIATIONS,
          CustomComponent: ContentVariationsPage,
          view: {}
        }
      ],
      containerStyle: {},
      dataConfig: {}
    };
  }

  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: BEACON_SUBTABS.CONTENT_UTILIZATION,
        CustomComponent: ContentUtilizationV3Page,
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
};

export default getContentV3PageLayout;
